import styled from 'styled-components';

export const NewsFeedTitle = styled.h2`
  padding: 8px;
  font-weight: bold;
  border-top: 1px solid ${({ theme }) => theme.news.palette.bor_lv2_pc};
`;
